// src/stockx/line/PlusIcon.ts
import { createIcon } from "@chakra-ui/icons";
var PlusIcon = createIcon({
  displayName: "PlusIcon",
  viewBox: "0 0 50 50",
  d: "M43 23.1H26.9V7H23.1V23.1H7V26.9H23.1V43H26.9V26.9H43V23.1Z"
});
var PlusIcon_default = PlusIcon;

export {
  PlusIcon_default
};
